<template>
  <div class="projektstammdaten">
    <v-row>
      <v-col>
        <h3>Projektstammdaten</h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <b-text-field
          label="Titel Verbund"
          type="text"
          v-model="titel_verbund"
        />
      </v-col>
      <v-col>
        <b-text-field
          label="Akronym"
          type="text"
          v-model="acronym_verbund"
        />
      </v-col>
      <v-col>
        <b-text-field
            label="Titel Teilvorhaben"
            type="text"
            v-model="titel_teilvorhaben"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <b-text-field
          label="Projektleiter"
          type="text"
          v-model="projektleiter"
          :disabled="true"
        />
      </v-col>
      <v-col>
        <b-text-field
          label="FKZ"
          type="text"
          v-model="foerderkennzeichen"
        />
      </v-col>
      <v-col>
        <b-text-field
          label="Kennwörter"
          type="text"
          v-model="kennwort" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4">
        <b-text-field
            label="Titel BKM"
            type="text"
            v-model="titel_bk" />
      </v-col>
      <v-col cols="4">
        <b-text-field
            label="Bezeichnung Förderprogramm"
            type="text"
            v-model="bezeichnung_foerderprogramm"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <b-date-field
            label="Laufzeit Beginn"
            v-model="laufzeitBeginn"
        />
      </v-col>
      <v-col>
        <b-date-field
            label="Laufzeit Ende"
            v-model="laufzeitEnde"
        />
      </v-col>
      <v-col>
        <b-text-field
            label="Bundesland"
            type="text"
            v-model="bundesland"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <b-text-field
            label="Empfängergruppe"
            type="text"
            v-model="empfängergruppe"
        />
      </v-col>
      <v-col>
        <b-text-field
            label="Rechtsform"
            type="text"
            v-model="rechtsform"
        />
      </v-col>
      <v-col>
        <b-text-field
            label="Abrechnungsart"
            type="text"
            v-model="abrechnungsart"
        />
      </v-col>
    </v-row>
    <!--
    <v-row>
      <v-col>
        <p>{{ verwertungAbgeschlossen ? 'Verwertung abgeschlossen' : 'Verwertung dauert noch an' }}</p>
      </v-col>
    </v-row>
    -->
  </div>
</template>

<script>
import dataMixin from '@/mixins/data-mixin';

export default {
  name: 'ProjektStammdaten',
  data() {
    return {
      ex_titles: ['Dr.', 'Prof.', ''],
      ex_salutations: ['Herr', 'Frau', ''],
    };
  },
  props: {
    projektleiter: undefined,
  },
  computed: {},
  mixins: [
    //Stammdaten
    dataMixin('titel', 'persistentData.projekt.titel'),

    dataMixin('titel_verbund', 'persistentData.projekt.titelVerbund'),
    dataMixin('acronym_verbund', 'persistentData.projekt.acronym'),
    dataMixin('titel_teilvorhaben', 'persistentData.projekt.titelTeilvorhaben'),

    dataMixin(
      'foerderkennzeichen',
      'persistentData.projekt.foerderkennzeichen'
    ),
    dataMixin('kennwort', 'persistentData.projekt.kennwort'),

    dataMixin('titel_bk', 'persistentData.projekt.titelBK'),
    dataMixin(
        'bezeichnung_foerderprogramm',
        'persistentData.projekt.bezeichnungFörderprogramm'
    ),
    dataMixin(
      'foerderkennzeichen_teilverband',
      'persistentData.projekt.foerderkennzeichenTV'
    ),

    dataMixin('laufzeitBeginn', 'persistentData.projekt.laufzeitBeginn'),
    dataMixin('laufzeitEnde', 'persistentData.projekt.laufzeitEnde'),
    dataMixin('bundesland', 'persistentData.projekt.bundesland'),

    dataMixin('empfängergruppe', 'persistentData.projekt.empfängergruppe'),
    dataMixin('rechtsform', 'persistentData.projekt.rechtsform'),
    dataMixin('abrechnungsart', 'persistentData.projekt.abrechnungsart'),

    dataMixin('verwertungAbgeschlossen', 'persistentData.projekt.verwertungAbgeschlossen'),
  ],
  methods: {

  },
};
</script>

<style scoped>
</style>

